import React, { FunctionComponent } from 'react';
import { ArticleModel } from '../../../../services/content/article/models/ArticleModel';

export const AdvertisementText: FunctionComponent<{ article: ArticleModel }> = ({ article }) => {
    const PRODUCT_PLACEMENT = 'product-placement';
    const ADVERTORIAL = 'advertorial';

    if (article.type === PRODUCT_PLACEMENT) {
        return (
            <strong>
                <i>{'(в материала има продуктово позициониране)'}</i>
            </strong>
        );
    }

    if (article.type === ADVERTORIAL) {
        return (
            <strong>
                <i>{'(платено съобщение)'}</i>
            </strong>
        );
    }

    return null;
};
